import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as Sentry from "@sentry/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';

Sentry.init({
  dsn: "https://a50780c1a8d280b31d5cdc3ad6e5b062@o4512078531526656.ingest.de.sentry.io/4512078536048720",
  dataCollection: {
    userInfo: false,
    httpBodies: []
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router>
      <App />
    </Router>
);